import type { Uuid } from '@sibe/utilities/common';
import type { HsGraphicsBuffer } from '../../graphic-render-new/types/graphic-buffer.type';
import type { HsBox } from '../../math-new/shapes/box.class';
import type { HsSphere } from '../../math-new/shapes/sphere.class';
import type { HsGeometryType } from './geometry-type.enum';
import type { HsGeometry } from './geometry.interface';

/** How a point geometry stores its colors after the positions: three floats, or three normalized bytes. */
export type HsPointColorFormat = 'float32' | 'rgb8';

export class HsRegularGeometry implements HsGeometry {
  public isDeleted: boolean = false;

  constructor(
    public readonly uuid: Uuid,
    public readonly geometryType: HsGeometryType,
    public readonly boundingBox: HsBox,
    public readonly boundingSphere: HsSphere,
    public readonly positionArrayLength: number,
    public readonly normalArrayLength: number,
    public readonly buffer: HsGraphicsBuffer,
    public readonly pointColorFormat: HsPointColorFormat = 'float32'
  ) {}
}
